// ============================================================================
// CabinetSupportTab.tsx — вкладка «Поддержка» кабинета.
//
// Не второй инбокс: используется существующий экран SupportInboxPage и
// существующие RPC SupportService. Режим определяет СЕРВЕР (роль «Поддержка»/
// админ — полный инбокс; остальные — «Мои обращения»); клиент лишь передаёт
// признак специалиста для UX (скрытие управляющих кнопок).
//
// В кабинете режим специалиста показан явно: переключатель «Мои обращения /
// Все обращения / Без исполнителя» (scopeSwitch), действия «Взять» и «Ответить»
// доступны в карточке обращения. Новых proto и серверных прав не требуется.
// ============================================================================

import { SupportInboxPage } from '@/pages/SupportInboxPage';
import { isSupportStaff } from '@/lib/supportInbox';
import { useSecurityAccess } from '@/lib/securityRoles';

export function CabinetSupportTab() {
  const access = useSecurityAccess();
  return <SupportInboxPage isStaff={isSupportStaff(access)} scopeSwitch />;
}
